export type PlaceAddress = {
  country: string;
  countryShortCode: string;
  region: string;
  regionShortCode: string;
  city: string;
  postalCode: string;
  streetAddress: string;
  unitNumber: string;
};

export const getPlaceAddress = (
  placeResult: google.maps.places.PlaceResult
): PlaceAddress => {
  let country = "";
  let countryShortCode = "";
  let region = "";
  let regionShortCode = "";
  let city = "";
  let streetName = "";
  let route = "";
  let subpremise = "";
  let postalCode = "";

  if (!placeResult?.address_components) {
    return {
      country,
      countryShortCode,
      region,
      regionShortCode,
      city,
      streetAddress: "",
      unitNumber: "",
      postalCode,
    };
  }

  placeResult.address_components.forEach((component) => {
    if (component.types.includes("country")) {
      country = component.long_name;
      countryShortCode = component.short_name;
      return;
    }

    if (
      component.types.includes("locality") ||
      component.types.includes("neighborhood")
    ) {
      city = component.long_name;
      return;
    }

    if (component.types.includes("administrative_area_level_1")) {
      region = component.long_name;
      regionShortCode = component.short_name;
      return;
    }

    if (
      component.types.includes("street_number") ||
      component.types.includes("street_address")
    ) {
      streetName = component.long_name;
      return;
    }

    if (component.types.includes("route")) {
      route = component.short_name;
      return;
    }

    if (component.types.includes("postal_code")) {
      postalCode = component.long_name;
      return;
    }

    if (component.types.includes("subpremise")) {
      subpremise = component.long_name;
    }
  });

  return {
    country,
    countryShortCode,
    region,
    regionShortCode,
    city,
    streetAddress: `${streetName && `${streetName} `}${route}`,
    unitNumber: subpremise,
    postalCode,
  };
};
